import api from './api';

export const fetchZipCodesInRadius = async (zipCode: string, radius: number): Promise<{ zipCodes: string[] }> => {
  try {
    console.log(`Fetching ZIP codes within ${radius} miles of ${zipCode}`);
    const response = await api.get(`/api/zipcode-radius?zip=${zipCode}&radius=${radius}`);
    console.log('ZIP codes API response:', response.data);
    return { zipCodes: response.data.zip_codes };
  } catch (error) {
    console.error('Error fetching ZIP codes:', error);
    throw new Error(error?.response?.data?.error || 'Failed to fetch ZIP codes');
  }
};